import { genericPage, getServerSidePropsHelper } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'embed']);
};

export async function getServerSideProps(context) {
    const { slugEmbed } = context.query;

    const path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'embed', 'app', slugEmbed];
    const options = {
        slugs: path
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
